import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouter } from '@tribeplatform/react-sdk';
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip';
import { getFieldIcon } from '../utils';
export const SocialMediaView = ({ field, value }) => {
    const { Link } = useRouter();
    return (_jsxs(Tooltip, { children: [_jsx(Tooltip.Trigger, { children: _jsx(Link, { href: value, target: "_blank", className: "w-6 h-6 flex-shrink-0 hover:opacity-80", onClick: e => e.stopPropagation(), children: getFieldIcon(field) }, void 0) }, void 0), _jsx(Tooltip.Panel, { children: field === null || field === void 0 ? void 0 : field.name }, void 0)] }, void 0));
};
SocialMediaView.skipLabel = true;
//# sourceMappingURL=SocialMediaView.js.map